/** Degradé horizontal multicolor (fondo superior de página). */
export const APP_SPECTRUM_GRADIENT = `linear-gradient(
  90deg,
  #dc2626 0%,
  #e11d48 4%,
  #be185d 8%,
  #c026d3 12%,
  #9333ea 16%,
  #7c3aed 20%,
  #4f46e5 24%,
  #2563eb 28%,
  #0284c7 32%,
  #0891b2 36%,
  #0f766e 40%,
  #059669 44%,
  #16a34a 48%,
  #65a30d 52%,
  #ca8a04 56%,
  #ea580c 60%,
  #dc2626 64%,
  #e11d48 68%,
  #be185d 72%,
  #c026d3 76%,
  #7c3aed 80%,
  #2563eb 84%,
  #0891b2 88%,
  #059669 92%,
  #ca8a04 96%,
  #dc2626 100%
)`;
